import { Carousel, Slide } from 'vue-carousel';

export default {
    name: 'heroSection',
    components: {
        Carousel,
        Slide
    },
    // async created() {
    //     await this.$loadScript("./vendor/slick/slick.min.js");
    //     await this.$loadScript("./js/slick-custom.js");
    // }
};
